import { parsePathString } from '../parser/parse-path-string';
export function path2Array(pathInput) {
    return parsePathString(pathInput);
}
//# sourceMappingURL=path-2-array.js.map